import React from 'react';
import 'twin.macro';
import { useTranslation } from 'react-i18next';
import ButtonLink from 'components/Buttons/Link';
import { PDFIcon } from 'components/Icons/icons/PDF';
import Tooltip2 from 'components/Tooltip2';

interface Props {
  previewLink: string;
}

export function PreviewDownloadButton(props: Props) {
  const { previewLink } = props;

  const { t } = useTranslation(['common', 'cahierJournal']);
  return (
    <Tooltip2 label={t('common:buttons.pdfPreview')}>
      <ButtonLink
        minimal
        icon={PDFIcon as any}
        to={previewLink}
        iconSize="lg"
        aria-label={t('common:buttons.pdfPreview')}
      />
    </Tooltip2>
  );
}
